import {
  doc,
  serverTimestamp,
  setDoc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../config/firebaseConfig";

//TODO: remove
export const createBusiness = async (business: any, uid: string) => {
  return setDoc(doc(db, "Businesses", uid), {
    business: business.business,
    orgNumber: business.orgNumber,
    name: business.name,
    email: business.email,
    sub_still_active: business.sub_still_active,
    plan: business.plan,
    timestamp: serverTimestamp(),
    uid: uid,
    paid: false,
    v2: business.v2,
    firstTimeOpening: business.firstTimeOpening,
    accountType: "premium",
  });
};

export const fetchUsers = async () => {
  try {
    const usersQuery = query(collection(db, "Users")); // Update the collection name accordingly
    const querySnapshot = await getDocs(usersQuery);
    const usersData = querySnapshot.docs.map((doc) => doc.data());
    return usersData;
  } catch (error) {
    console.error("Error fetching users: ", error);
  }
};

export const fetchJobAds = async (businessProfileUid: string) => {
  try {
    const jobAdsQuery = query(
      collection(db, "JobAds"),
      where("businessUid", "==", businessProfileUid),
      where("adActive", "==", true)
    );
    const querySnapshot = await getDocs(jobAdsQuery);
    const jobAdsData = querySnapshot.docs.map((doc) => doc.data());
    return jobAdsData;
  } catch (error) {
    console.error("Error fetching job ads: ", error);
  }
};
